import React from 'react';
import { EMAIL_STYLES, STYLE_DESCRIPTIONS } from '../types';
import { Check } from 'lucide-react';

const StyleSelector = ({ selectedStyle, onStyleChange, className = '' }) => {
  return (
    <div className={`space-y-4 ${className}`}>
      <label className="block text-sm font-medium text-gray-700">
        Choose a newsletter style
      </label>
      
      <div className="grid grid-cols-1 md:grid-cols-2 gap-3">
        {EMAIL_STYLES.map((style) => (
          <button
            key={style}
            onClick={() => onStyleChange(style)}
            className={`relative p-4 text-left rounded-lg border-2 transition-all duration-200 ${
              selectedStyle === style
                ? 'border-primary-500 bg-primary-50'
                : 'border-gray-200 bg-white hover:border-gray-300 hover:bg-gray-50'
            }`}
          >
            {selectedStyle === style && (
              <div className="absolute top-2 right-2">
                <Check className="w-4 h-4 text-primary-600" />
              </div>
            )}
            
            <div className="pr-6">
              <h3 className={`font-medium text-sm ${
                selectedStyle === style ? 'text-primary-900' : 'text-gray-900'
              }`}>
                {style}
              </h3>
              <p className={`text-xs mt-1 ${
                selectedStyle === style ? 'text-primary-700' : 'text-gray-500'
              }`}>
                {STYLE_DESCRIPTIONS[style]}
              </p>
            </div>
          </button>
        ))}
      </div>
    </div>
  );
};

export default StyleSelector; 